export const skipToastErrors = {
  REMOVE_VARIANTS_BEFORE_DISABLE_VARIATION: 'you_can_change_task_to_not_varianted_is_one_variant',
};

